export default "__VITE_ASSET__BiHsdx1N__"